export const slugify = (text) => {
  return text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '_')        // Replace spaces with _
    .replace(/[^\w-]+/g, '')     // Remove all non-word chars
    .replace(/--+/g, '_')        // Replace multiple - with single _
    .replace(/^-+/, '')          // Trim - from start of text
    .replace(/-+$/, '');         // Trim - from end of text
};